import React, {ReactElement} from 'react';
import {perDay} from 'core/LifeCycle';
import {createBudget} from 'core/Budget';
import {calcDailyBudget} from 'core/DailyBudget';
import {useBudgetStore} from 'store/Budget';
import {toReadable} from 'shared/utils/number';
import {daysBetween, getTodayStartTime} from 'shared/utils/dateTime';
import {useFutureDailyAmount, useFutureBudgetAmount} from 'ui/utils/core';

import {DynamicFontSize} from 'components/DynamicFontSize';
import {Section} from 'components/Section';
import {Shout, Text} from 'components/Text';

export const LimitBreach = (): ReactElement => {
  const budget = useBudgetStore();
  const futureAmount = useFutureDailyAmount();
  const futureBudgetRemainder = useFutureBudgetAmount();

  if (futureAmount > 0) return null;
  if (futureBudgetRemainder <= 0) return null;

  const oldDaily = perDay(budget);
  const daysCount = daysBetween(budget.finishDate, getTodayStartTime()) - 1;
  const newBudget = createBudget(futureBudgetRemainder, daysCount);
  const newDailyBudget = calcDailyBudget(newBudget, []);

  return (
    <Section>
      <Shout color='red' data-test='value'>
        <DynamicFontSize>{toReadable(newDailyBudget.amount)}</DynamicFontSize>
      </Shout>
      <Text data-test='label'>Новый бюджет на день. Было {toReadable(oldDaily)}</Text>
    </Section>
  );
};
